import { useTeam } from '@vrplatform/data';
import { LedgerListingDetailDrawer } from './LedgerListingDetailDrawer';
import { LegacyListingDetailDrawer } from './LegacyListingDetailDrawer';

export const ListingDetailDrawer = () => {
  const [{ isGL: GL }] = useTeam();

  if (GL) return <LedgerListingDetailDrawer />;

  return <LegacyListingDetailDrawer />;
};
